import classes from 'components/Feedback/Feedback.module.scss';
import Constants from 'config/constants';

export default function Feedback(props) {
	const handleFeedback = () => {
		if (typeof window.KAMPYLE_ONSITE_SDK !== 'undefined') {
			// eslint-disable-next-line no-undef
			KAMPYLE_ONSITE_SDK.showForm(props.pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? Constants.SURVEY_ID_GG : (props.pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? Constants.SURVEY_ID_PL : Constants.SURVEY_ID_DSG));
		}
	}

	return (
		<div data-test-id="feedback-main">
			<div className={classes.FeedbackContainer}>
				<p className="body-small" style={{color: "#191F1C"}}>How are we doing?</p>
				<div className={classes.FeedbackLink}>
					<p className={`link-text ${props.pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? "link-hover-gg" : (props.pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? "link-hover-pl" : "link-hover-dsg")}`}
						 onClick={handleFeedback}>
						Give Us Feedback On This Page.</p>
				</div>
			</div>
		</div>
	);
}
